// Completely unnecessary to be a class, but I wanted to try get the hang of es6 classes... (Liam)

class Affix {
	constructor(element, trigger){
		this.element = typeof(element) === 'string' ? document.querySelector(element) : element;
		this.top = (trigger instanceof HTMLElement) ? trigger.offsetTop : parseInt(trigger);
		this.triggerEle = (trigger instanceof HTMLElement) ? trigger : null;

		window.addEventListener('scroll', () => this.checkPosition(), { passive: true });
		window.addEventListener('resize', () => this.resize(), { passive: true });

		this.checkPosition();
	}

	checkPosition(){
		if(document.scrollingElement !== null && document.scrollingElement.scrollTop > this.top) {
			this.element.classList.add('affixed');
		} else {
			this.element.classList.remove('affixed');
		}
	}

	resize(){
		if(this.triggerEle !== null) {
			this.top = this.triggerEle.offsetTop;
		}

		this.checkPosition();
	}
}

export { Affix as default };
